export const senderGroupingsActionButtonTooltipText = "$Klpce";
export default {senderGroupingsActionButtonTooltipText};